<div class="container">
  <h4>Camera Application Management</h4>
  <div class="d-flex flex-column flex-md-row justify-content-center mt-3">
    <button
      [routerLink]="['sites']"
      type="button"
      class="btn btn-status-inprocess flex-fill m-1"
    >
      Sites
    </button>
    <button
      [routerLink]="['users']"
      type="button"
      class="btn btn-info flex-fill m-1"
    >
      Users
    </button>
    <button
      [routerLink]="['alerts']"
      type="button"
      class="btn btn-warning flex-fill m-1"
    >
      Alerts
    </button>
  </div>
</div>
